/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Col, FormGroup, FormFeedback, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import "react-table-legacy/react-table.css";
import ReactTable from 'react-table-legacy'

import InputNumber from 'rc-input-number';

import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';

import {AppContext} from '../AppContext';

class SuggestedKValuesModal extends React.Component
{
  inputRef = null;
  
  async addNewSuggestedValue()
  {
    if ('' === this.state.keywordValue.toString())
    {
      this.setState({validValue: false});
      return;
    }

    this.setState({buttonDisabled: true});

    var bodyData = {};
    bodyData.keywordId = this.props.keywordInfo.keywordId;
    bodyData.keywordValue = this.state.keywordValue;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createSuggestedKeywordValue', bodyData);
    if ('success' !== result.status)
    {
      this.setState({buttonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error adding suggested value');
    } 
    this.context.postNotification('info', 'Changes saved.');
    this.props.refresh(this.props.keywordInfo.keywordId);
    this.setState(
    {
      dateValue: null, timestapValue: null, timeValue: null, timestampValue: null, 
      integerValue: null, floatingPointValue: null, keywordValue: '',
      buttonDisabled: true
    });
    this.setFocus();
  }

  cancelModal()
  {
    this.props.closeModal(false);
  }

  constructor(props) 
  {
    super();

    this.state =
    {
      keywordName: null,
      showKeywordValue: false,
      showDateValue: false,
      showTimestampValue: false,
      showIntegerValue: false,
      showFloatingPointValue: false,
      showTimeValue: false,
      dateValue: null,
      timeValue: null,
      timestampValue: null,
      integerValue: null,
      floatingPointValue: null,
      keywordValue: '',
      validValue: true,
      buttonDisabled: true
    }

    this.cancelModal = this.cancelModal.bind(this);
    this.addNewSuggestedValue = this.addNewSuggestedValue.bind(this);
    this.integerValueChanged = this.integerValueChanged.bind(this);
    this.floatingPointValueChanged = this.floatingPointValueChanged.bind(this);
    this.setDate = this.setDate.bind(this);
    this.setTime = this.setTime.bind(this);
    this.setTimestamp = this.setTimestamp.bind(this);
    this.setFocus = this.setFocus.bind(this);
  }

  async deleteSuggestedValue(rowInfo)
  {
    var bodyData = {};
    bodyData.valueId = rowInfo.row.valueId;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'deleteSuggestedKeywordValue', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error deleting suggested value');
    this.context.postNotification('info', 'Suggested keyword value deleted.');
    this.props.refresh(this.props.keywordInfo.keywordId);
  }

  floatingPointValueChanged(valueAsNumber, valueAsString, input)
  {
    let disabled = false;
    if (null === valueAsNumber) disabled = true;

    this.setState(
    {
      floatingPointValue: valueAsNumber, 
      keywordValue: valueAsNumber, 
      buttonDisabled: disabled
    });
  }

  integerValueChanged(valueAsNumber, valueAsString, input)
  {
    let disabled = false;
    if (null === valueAsNumber) disabled = true;

    this.setState(
    {
      integerValue: valueAsNumber, 
      keywordValue: valueAsNumber, 
      buttonDisabled: disabled
    });
  }

  renderKeywordValue(data)
  {
    if ('date' === data.keywordValueType)
      return window.moment.unix(data.keywordValue).utc().format('LL');
    else if ('timestamp' === data.keywordValueType)
      return window.moment.unix(data.keywordValue).utc().format('LL LTS');
    else if ('time' === data.keywordValueType)
      return window.moment.unix(data.keywordValue).utc().format('LTS');
    else
      return data.keywordValue;
  }

  renderInputElement()
  {
    if (null === this.props.keywordInfo) return null;

    switch (this.props.keywordInfo.keywordValueType)
    {
      case 'character':
        return(
          <Input type="text" id="keywordValue" placeholder="Enter a new suggested value..." 
            value={this.state.keywordValue} autoFocus innerRef={(ref) => this.inputRef = ref} 
            onChange={(event) =>
            {
              this.setState({keywordValue: event.currentTarget.value, buttonDisabled: ('' === event.target.value ? true : false)});
            }}
          />
        );

      case 'integer':
        return(
          <InputNumber id='integerValue' value={this.state.integerValue} onChange={this.integerValueChanged}
            placeholder={'Specify an integer value....'} autoFocus={true} ref="inputNumber" />  
        );

      case 'floating point':
        return(
          <InputNumber id='floatingPointValue' precision={3} value={this.state.floatingPointValue}
            onChange={this.floatingPointValueChanged} placeholder='Specify a floating point value...' autoFocus={true} ref="inputNumber"/>
        );
        
      case 'date':
        return(<Datetime timeFormat={false} onChange={this.setDate} value={this.state.dateValue} utc={true} />);

      case 'time':
        return(<Datetime dateFormat={false} onChange={this.setTime} value={this.state.timeValue} utc={true} />);

      case 'timestamp':
        return(<Datetime onChange={this.setTimestamp} value={this.state.timestampValue} utc={true}/>);

      default:
        return(
          <b> Unknown keyword value type....</b>
        );
    }
  }

  render()
  {
    if (null === this.props.keywordGroup || undefined === this.props.keywordGroup) return null;
    
    var keyword = '';
    if (null !== this.props.keywordInfo) keyword = this.props.keywordInfo.keyword;

    const columns =
    [
      {id: 'valueId', accessor: 'valueId', show: false},
      {id: 'keywordValue', Header: 'Keyword Value', accessor: this.renderKeywordValue},
      {id: 'deleteButton', Header: '', Cell: (rowInfo) => { return (<Button color="secondary" onClick={this.deleteSuggestedValue.bind(this, rowInfo)}>Delete</Button>)}}
    ];

    let inputElement = this.renderInputElement();

    let formFeedback = (this.state.validValue ? null : 'You must specify a suggested value.');

    return(  
      <Modal isOpen={this.props.modalIsOpen} toggle={this.cancelModal} autoFocus={false}>
        <ModalHeader toggle={this.cancelModal}>Suggested Keyword Values<br />For "{keyword}" in Group "{this.props.keywordGroup.keywordGroup}"</ModalHeader>
        <ModalBody>
          <FormGroup row>
            <Label for="newSuggestedValue" sm="9">New Suggested Value...</Label>
            <Col sm="9">
              {inputElement}
              <FormFeedback valid={false} >{formFeedback}</FormFeedback>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Button color="primary" disabled={this.state.buttonDisabled} onClick={this.addNewSuggestedValue}>Add value</Button>
            </Col>
          </FormGroup>
          <ReactTable data={this.props.suggestedKeywordValues} showPagination={false} columns={columns} minRows={1} className="-striped -highlight" />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.cancelModal}>OK</Button>
        </ModalFooter>
      </Modal>
    );
  }

  setDate(parm)
  {
    let disabled = (parm ? false : true);

    this.setState(
    {
      dateValue: parm,
      keywordValue: (parm ? parm.unix() : ''),
      buttonDisabled: disabled
    });
  }

  setFocus()
  {
    switch (this.props.keywordInfo.keywordValueType)
    {
      case 'integer':
      case 'floating point':
      case 'US Dollar':
        this.inputNumber.refsInput.focus();
        break;


      case 'character':
        this.inputRef.focus();
        break;

      case 'date':
      case 'time':
      case 'timestamp':
        break;


      default:
        break;
    }
  }

  setTime(parm)
  {
    let disabled = (parm ? false : true);

    this.setState(
    {
      timeValue: parm,
      keywordValue: (parm ? parm.unix() : ''),
      buttonDisabled: disabled
    });
  }

  setTimestamp(parm)
  {
    let disabled = (parm ? false : true);

    this.setState(
    {
      timestampValue: parm,
      keywordValue: (parm ? parm.unix() : ''),
      buttonDisabled: disabled
    });
  }
}

SuggestedKValuesModal.contextType = AppContext;

export default SuggestedKValuesModal